import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { formatCurrency, formatToFloat } from '../../../utils/formatCurrency';

export function ListProducts(props: any) {
    
    return (
        <Table className="border ml-3 mt-0">
            <TableHead>
                <TableRow>
                    <TableCell>Cod.</TableCell>
                    <TableCell>Quantidade</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Valor</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>IPI</TableCell>
                    <TableCell>ICMS</TableCell>
                    <TableCell>CFOP</TableCell>
                    <TableCell>NCM</TableCell>
                    <TableCell>Total</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.products.map((product: any) => (
                    <TableRow key={product.INSTANCE.id}>
                        <TableCell>{product.INSTANCE.code}</TableCell>
                        <TableCell>{product.amount}</TableCell>
                        <TableCell>{product.INSTANCE.name}</TableCell>
                        <TableCell>{formatCurrency(product.INSTANCE.saleValue)}</TableCell>
                        <TableCell>{ product.INSTANCE.type == 'product' ? 'Produto' : 'Serviço' }</TableCell>
                        <TableCell>{formatCurrency(product.ipi)}</TableCell>
                        <TableCell>{formatCurrency(product.icms)}</TableCell>
                        <TableCell>{formatCurrency(product.cfop)}</TableCell>
                        <TableCell>{product.ncm}</TableCell>
                        <TableCell>{formatCurrency(product.total)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}